import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, UseFormReturn } from 'react-hook-form'
import { object } from 'yup'

import { usePersonGeneralData } from 'hooks'
import { FamilyContact } from 'models/Auth'
import { familyContactSchema } from 'utils/schemas'

type FamilyContactFormMethods = UseFormReturn<{ familyContact: FamilyContact }>

type FormMethods = {
  formMethods: FamilyContactFormMethods
  userData: ReturnType<typeof usePersonGeneralData>['userData']
  hasRelativeData: boolean
}

const schema = object().shape({
  familyContact: familyContactSchema
})

export const useEditFamilyContactForm = (): FormMethods => {
  const { userData, hasRelativeData } = usePersonGeneralData()
  
  const formMethods = useForm({
    criteriaMode: 'all',
    mode: 'all',
    resolver: yupResolver(schema),
    defaultValues: {
      familyContact: {
        fullName: userData.relative_data?.relative_full_name || '',
        relationship: userData.relative_data?.relationship_degree || null,
        phone: userData.relative_data?.relative_phone_number || ''
      }
    }
  })

  return {
    formMethods,
    userData,
    hasRelativeData
  }
}